import React, { Component } from "react";
import { connect } from "react-redux";
import { actions, selectors } from "../redux";
import { Base } from "zina-dogi-react";
import { utils } from "~/utils";
import * as cpo from "~/sode/cpo/redux";
import * as master_budget from "../../master_budget/redux"
import { NonSodeFilter, NonSodeTable } from "../components";

class NonSODEList extends Component {
    filter = React.createRef();

    componentDidMount() {
        this.props.list();
    }

    onFilter = filters => {
        return this.props.list(1, filters);
    };

    onCreate = non_sode => {
        return this.props.create(non_sode).then(() => this.props.list(1));
    };

    render() {
        const { fields, non_sodes, pagination, loading, extraProps } = this.props;
        const base_op = {
            className: "non_sode_list",
            title: "NON SODE inbox",
            breadcrumbs: [{ name: "Home", rel: "/inbox-non-sode/", icon: "home" }, { name: "NON SODE inbox" }],
            extraProps,
            loading
        };
        const cpoTable_op = {
            non_sodes,
            pagination: {
                ...pagination,
                changePage: (page) => {
                    const filterRef = this.filter.current;
                    const djform = filterRef && filterRef.djform && filterRef.djform.current;
                    const formik = djform && djform.formik && djform.formik.current;
                    let filters = utils.clearObjectNulls(
                        formik && formik.state ? formik.state.values : {}
                    );
                    this.props.list(page, filters);
                }
            },
            className: "cpo_table"
        };
        return (
            <Base {...base_op}>
                <NonSodeFilter
                    ref={this.filter}
                    className="filters"
                    fields={fields}
                    onFilter={this.onFilter}
                    onCreate={this.onCreate}
                    listCircles={this.props.listCircles}
                    getChoices={this.props.getChoices}
                />
                <NonSodeTable {...cpoTable_op} />
            </Base>
        );
    }
}

const mapStateToProps = store => ({
    fields: selectors.fields(store.non_sode),
    non_sodes: selectors.listItemsArray(store.non_sode),
    pagination: selectors.pagination(store.non_sode),
    loading: store.non_sode.loading,
    loaded: store.non_sode.loaded
});
const mapDispatchToProps = dispatch => ({
    list: (page, filters) => dispatch(actions.list(page, filters)),
    create: non_sode => dispatch(actions.create(non_sode)),
    listCircles: search => dispatch(cpo.actions.listCircles(search)),
    getChoices: filters => dispatch(master_budget.actions.getChoices(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(NonSODEList);
